module.exports = __webpack_public_path__ + "media/images/og_home-ecad25c3d81d40b1dc64e7d166cb1522.jpg";